import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';

/** 标识 */
export const DONATION_TIME_KEY = 'GOOD-DEED-DAY';

/** 当日时间 */
export const TODAY_TIME = dayjs(getServerTime()).format('YYYY-MM-DD');

/** 从localStorage获得当日捐赠次数 */
export const getDonationErrTimes = (): number => {
  const storageDonationTimes = localStorage.getItem(DONATION_TIME_KEY);
  const { time, num } = JSON.parse(storageDonationTimes || '{"time":"","num":0}');
  if (time && num) {
    const now = getServerTime();
    // 如果是当天的数据
    if (dayjs(now).isSame(dayjs(time), 'day')) {
      return num;
    }
  }
  return 0;
};

/** 把当日捐赠次数更新到localStorage中 */
export const updateDonationErrTimes = (value: number) => {
  localStorage.setItem(
    DONATION_TIME_KEY,
    JSON.stringify({
      time: TODAY_TIME,
      num: value,
    }),
  );
};
